import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { SitioProcesamiento } from './sitios-procesamiento.model';

export const entitySitiosProcesamientoAdapter: EntityAdapter<SitioProcesamiento> =
  createEntityAdapter<SitioProcesamiento>({
    selectId: (model) => model.id,
    sortComparer: (a: SitioProcesamiento, b: SitioProcesamiento): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntitySitiosProcesamientoState extends EntityState<SitioProcesamiento> {
  isLoading?: boolean;
  hasAddedSuccess?: boolean;
  error?: Error | null;
}

export const initialState: EntitySitiosProcesamientoState =
  entitySitiosProcesamientoAdapter.getInitialState({
    hasAddedSuccess: false,
    isLoading: false,
    error: null
  });
